import { useLocalStoreWithDep } from "designSystem/hooks";
import { observer } from "mobx-react-lite";
import React, { FunctionComponent } from "react";
import { MultiSelectComponent } from "../index";
import { EnumProps, EnumStore } from "./EnumStore";

export const EnumList: FunctionComponent<EnumProps> = observer(({ attributeId, nodeType, nodeUrl, reportOperations }) => {
	const enumStore = useLocalStoreWithDep(() => new EnumStore(attributeId, nodeType, nodeUrl, reportOperations), [reportOperations]);

	return (
		<MultiSelectComponent aggregateStore={enumStore?.store} />
	);
});
